import {
  QueryKey,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import Api from "../api/generalApi/Api";
import { Method, Methods } from "../Constants/ApiConstants";
import i18n from "../i18n";

type FetchOptions<Res> = Omit<
  UseQueryOptions<Res, Error, Res, QueryKey>,
  "queryKey" | "queryFn"
>;

interface UseFetchDataConfig<Res, Req = undefined> {
  body?: Req;
  queryParams?: Record<string, any>;
  options?: FetchOptions<Res>;
  token?: string;
  lang?: "en" | "ar";
}

const useFetchData = <Res, Req = undefined>(
  queryKey: QueryKey,
  endpoint: string,
  method: Method = Methods.GET, // method is of type Method
  config?: UseFetchDataConfig<Res, Req>,
): UseQueryResult<Res, Error> => {
  return useQuery<Res, Error>({
    queryKey: [...queryKey, i18n.language],
    queryFn: () =>
      Api<Req, Res>({
        method, // Pass single method
        endpoint,
        body: config?.body,
        customToken: config?.token,
        customLanguage: config?.lang,
        filter: config?.queryParams
          ? Object.entries(config.queryParams).map(([key, value]) => ({
              [key]: value,
            }))
          : undefined,
      }),
    ...config?.options,
  });
};

export default useFetchData;
